import PropTypes from 'prop-types'
import React from 'react'

const BreakText = ({ text, paragraphs }) => {
    return (
        <div>
            {text.split('\n').map((item, key) => {
                if (item.length === 0) {
                    return null
                }
                if (paragraphs) {
                    return <p key={key}>{item}</p>
                } else {
                    return (
                        <span key={key}>
                            {item}
                            <br />
                        </span>
                    )
                }
            })}
        </div>
    )
}

BreakText.propTypes = {
    text: PropTypes.string.isRequired,

    paragraphs: PropTypes.bool, // break text in <p> tags
}

export default BreakText
